import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  Campaign,
  CategoryLinkType,
  CategoryType,
  CampaignType,
} from "@vviinn/user-managment-client-ts";
import { ApiRequest, serializeModel } from "../../../api";
import { SiteRequest } from "../../../site";

export type CategoryRequest = SiteRequest & {
  campaignId: Campaign["id"];
  categoryCode: string;
  categoryLinkType: CategoryLinkType;
  categoryType: CategoryType;
  optionalCampaignType?: CampaignType;
};

export const linkCategory = createAsyncThunk(
  "categories/assign",
  async ({ api, value }: ApiRequest<CategoryRequest>) => {
    const {
      companyId,
      campaignId,
      siteId,
      categoryCode,
      categoryLinkType,
      categoryType,
      optionalCampaignType,
    } = value;

    const response = await api.linkCategoryToCampaignWithCategoryType(
      companyId,
      siteId,
      campaignId,
      categoryCode,
      categoryLinkType,
      categoryType,
      optionalCampaignType,
    );

    return serializeModel(response.value);
  },
);

export const unLinkCategory = createAsyncThunk(
  "categories/assign",
  async ({ api, value }: ApiRequest<CategoryRequest>) => {
    const {
      companyId,
      campaignId,
      siteId,
      categoryCode,
      categoryLinkType,
      categoryType,
      optionalCampaignType,
    } = value;

    const response = await api.unlinkCategoryFromCampaignWithCategoryType(
      companyId,
      siteId,
      campaignId,
      categoryCode,
      categoryLinkType,
      categoryType,
      optionalCampaignType,
    );

    return serializeModel(response.value);
  },
);
